export default __webpack_public_path__ + "static/media/money-bill-wave.38d47239.svg";